"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hiddenSelectorSx = void 0;
const hiddenSelectorSx = exports.hiddenSelectorSx = {
  opacity: 0,
  pointerEvents: 'none',
  position: 'absolute'
};